import { Link } from "react-router-dom";
import PublicShell from "../layout/PublicShell";

const UPDATED = "April 2026";

export default function Terms() {
  return (
    <PublicShell minimal>
      <article className="max-w-[680px] mx-auto px-6 py-16">
        <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-ink-faint">
          legal · terms
        </div>
        <h1 className="mt-3 font-serif text-3xl md:text-4xl leading-tight">
          The deal, in plain English.
        </h1>
        <p className="mt-2 font-mono text-[11px] text-ink-faint">Last updated: {UPDATED}</p>

        <section className="mt-10 space-y-5 text-[15px] leading-relaxed text-ink-soft">
          <p>
            By creating an account you agree to these terms. They're short,
            written by a human, and we'll always tell you when they change.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">What we provide</h2>
          <p>
            A language tutor that messages you on Telegram. The tutor uses
            language models to generate replies — we don't promise factual
            accuracy or perfect grammar in every reply, only that we tune the
            system to be honest about what it knows.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">Your account</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>One person per account. You're responsible for what happens on it.</li>
            <li>You must be 16 or older.</li>
            <li>If you let someone else use your account, that's on you.</li>
          </ul>

          <h2 className="font-serif text-xl text-ink mt-8">Acceptable use</h2>
          <p>
            Don't use ilmli to harass anyone, scrape its outputs to retrain
            other models, or attempt to extract operational secrets from the
            bot. We'll terminate the account if you do.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">Billing</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Free 7-day trial; no card required.</li>
            <li>Paid plans renew monthly until you cancel. Cancel any time from{" "}
              <Link to="/app/profile" className="underline decoration-ink-faint/40 hover:decoration-terracotta">
                Settings → Plan
              </Link>
              .</li>
            <li>Refunds within 14 days of a charge if you ask. After that, no.</li>
            <li>Voice notes are metered per the limit shown on your plan. Text replies are unlimited on every paid plan.</li>
          </ul>

          <h2 className="font-serif text-xl text-ink mt-8">Liability</h2>
          <p>
            We provide ilmli "as is". We're not liable for losses arising from
            outages, message-generation errors, or third-party services we
            depend on (Telegram, OpenRouter, AWS, Stripe). Your maximum claim
            against us is whatever you paid us in the 12 months before the
            claim — typically a few dollars.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">Termination</h2>
          <p>
            You can delete your account from{" "}
            <Link to="/app/profile" className="underline decoration-ink-faint/40 hover:decoration-terracotta">
              Settings → Account
            </Link>
            {" "}any time. We can terminate accounts that violate these terms, with notice.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">Changes</h2>
          <p>
            If we change these terms in any material way, we'll email the
            account address before the change takes effect. Continued use after
            that means you accept the new terms.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">Governing law</h2>
          <p>
            These terms are governed by the laws of the operator's place of
            business; disputes are settled there. We'd much rather sort
            things out by email — try{" "}
            <a href="mailto:hello@ilmli.ai" className="underline">hello@ilmli.ai</a> first.
          </p>
        </section>

        <div className="mt-12 pt-6 border-t border-[rgba(42,36,26,0.12)] text-[13px] text-ink-faint">
          See also: <Link to="/privacy" className="underline decoration-ink-faint/40 hover:decoration-terracotta">Privacy</Link>{" "}
          · <Link to="/" className="underline decoration-ink-faint/40 hover:decoration-terracotta">Home</Link>
        </div>
      </article>
    </PublicShell>
  );
}
